var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBorderFull = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33341 16.6666V3.33331",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 3.33331V16.6666",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.33325 3.33335H16.6666",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6666 16.6667H3.33325",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4254 9.94999C13.4254 9.92666 13.407 9.90833 13.3837 9.90833C13.3604 9.90833 13.342 9.92666 13.342 9.94999C13.342 9.97333 13.3604 9.99166 13.3837 9.99166C13.407 9.99166 13.4254 9.97333 13.4254 9.94999",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.75838 9.94999C6.75838 9.92666 6.74005 9.90833 6.71672 9.90833C6.69338 9.90833 6.67505 9.92666 6.67505 9.94999C6.67505 9.97333 6.69338 9.99166 6.71672 9.99166C6.74005 9.99166 6.75838 9.97333 6.75838 9.94999",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0919 9.94999C10.0919 9.92666 10.0735 9.90833 10.0502 9.90833C10.0269 9.90833 10.0085 9.92666 10.0085 9.94999C10.0085 9.97333 10.0269 9.99166 10.0502 9.99166C10.0735 9.99166 10.0919 9.97333 10.0919 9.94999",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0502 13.325C10.0735 13.325 10.0919 13.3067 10.0919 13.2834C10.0919 13.26 10.0735 13.2417 10.0502 13.2417C10.0269 13.2417 10.0085 13.26 10.0085 13.2834C10.0085 13.3067 10.0269 13.325 10.0502 13.325",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0502 6.65835C10.0735 6.65835 10.0919 6.64001 10.0919 6.61668C10.0919 6.59335 10.0735 6.57501 10.0502 6.57501C10.0269 6.57501 10.0085 6.59335 10.0085 6.61668C10.0085 6.64001 10.0269 6.65835 10.0502 6.65835",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBorderFull);
export default ForwardRef;